(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/icon_cta', ['react'], factory) :
  (global = global || self, global['@fdn/icon_cta'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "header-cta-wrapper"
    }, props.badge_count > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "badge"
    }, props.badge_count) : null, props.link !== '' ? /*#__PURE__*/React.createElement("a", {
      href: props.link,
      className: "cta-button",
      id: props.element_id,
      "aria-label": props.aria_label
    }, /*#__PURE__*/React.createElement("span", {
      className: props.icon_class
    })) : /*#__PURE__*/React.createElement("button", {
      id: props.element_id,
      onClick: props.on_click,
      className: "cta-button",
      "aria-label": props.aria_label
    }, /*#__PURE__*/React.createElement("span", {
      className: props.icon_class
    })), /*#__PURE__*/React.createElement("style", null, "\n          .header-cta-wrapper {\n            display: block;\n            position: relative;\n          }\n\n          .header-cta-wrapper .badge {\n            width: 16px;\n            height: 16px;\n            border-radius: 50%;\n            background-color: ".concat(props.type === 'monochrome' ? '#000' : '#D7244E', ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-family: Roboto, sans-serif;\n            color: #FFF;\n            font-size: 8px;\n            position: absolute;\n            top: 0;\n            right: -8px;\n          }\n\n          .header-cta-wrapper .cta-button {\n            display: flex;\n            width: 36px;\n            height: 36px;\n            padding: 0;\n            background-color: ").concat(props.type === 'monochrome' ? 'transparent' : '#F4F6F8', ";\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            outline: none;\n            border: none;\n            cursor: pointer;\n            color: #000;\n          }\n\n          .header-cta-wrapper .cta-button * {\n            max-width: 45%;\n            width: 100%;\n            height: auto;\n          }\n\n          .header-cta-wrapper .cta-button span {\n            font-size: 28px;\n          }\n\n          .header-cta-wrapper .cta-button span::before {\n            display: block;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n          \n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "header-cta-wrapper"
    }, props.badge_count > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "badge"
    }, props.badge_count) : null, props.link !== '' ? /*#__PURE__*/React.createElement("a", {
      href: props.link,
      className: "cta-button",
      id: props.element_id,
      "aria-label": props.aria_label
    }, /*#__PURE__*/React.createElement("span", {
      className: props.icon_class
    })) : /*#__PURE__*/React.createElement("button", {
      id: props.element_id,
      onClick: props.on_click,
      className: "cta-button",
      "aria-label": props.aria_label
    }, /*#__PURE__*/React.createElement("span", {
      className: props.icon_class
    })), /*#__PURE__*/React.createElement("style", null, "\n          .header-cta-wrapper {\n            display: block;\n            position: relative;\n          }\n\n          .header-cta-wrapper .badge {\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            background-color: ".concat(props.type === 'monochrome' ? '#000' : '#D7244E', ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-family: Roboto, sans-serif;\n            color: #FFF;\n            font-size: 6px;\n            position: absolute;\n            top: 0;\n            right: -5px;\n          }\n\n          .header-cta-wrapper .cta-button {\n            display: flex;\n            width: 28px;\n            height: 28px;\n            padding: 0;\n            background-color: ").concat(props.type === 'monochrome' ? 'transparent' : '#F4F6F8', ";\n            border-radius: 50%;\n            align-items: center;\n            justify-content: center;\n            outline: none;\n            border: none;\n            cursor: pointer;\n            color: #000;\n          }\n\n          .header-cta-wrapper .cta-button * {\n            max-width: 45%;\n            width: 100%;\n            height: auto;\n          }\n\n          .header-cta-wrapper .cta-button span {\n            font-size: 20px;\n            position: relative;\n          }\n\n          .header-cta-wrapper .cta-button span::before {\n            display: block;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          }\n          \n        ")));
  };

  var IconCTA = function IconCTA(_ref) {
    var is_mobile = _ref.is_mobile,
        icon_class = _ref.icon_class,
        element_id = _ref.element_id,
        badge_count = _ref.badge_count,
        link = _ref.link,
        on_click = _ref.on_click,
        type = _ref.type,
        aria_label = _ref.aria_label;
    var props = {
      is_mobile: is_mobile || false,
      icon_class: icon_class || '',
      element_id: element_id || null,
      badge_count: badge_count || 0,
      link: link || '',
      type: type || null,
      on_click: on_click || function () {
        return false;
      },
      aria_label: aria_label || null
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  return IconCTA;

})));
//# sourceMappingURL=icon_cta.umd.js.map
